import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'

import Root from 'containers/Root'

ReactDOM.render(<Root />, document.getElementById('root'))